import { createSlice } from '@reduxjs/toolkit';
import { logout } from 'src/store/actions/authActions';
import {
  DEVICE_SLICE,
  setDeviceDetails,
  setParameterDetails,
} from 'src/store/actions/deviceActions';
import { Device, IParameter } from 'src/store/models/Device';

export interface DeviceState {
  deviceDetails: Device;
  parameters: IParameter[];
}

const initialState: DeviceState = {
  deviceDetails: null,
  parameters: [],
};

const deviceSlice = createSlice({
  name: DEVICE_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setDeviceDetails, (state, action) => {
        state.deviceDetails = action.payload;
      })
      .addCase(setParameterDetails, (state, action) => {
        state.parameters = action.payload;
      })
      .addCase(logout, (state) => {
        state = initialState;
      });
  },
});

export default deviceSlice.reducer;
